import styles from "./Headline.module.css";

const Headline = ({ textHeadline }) => {
  return <h3 className={styles.containerText}>{textHeadline}</h3>;
};

export default Headline;
